import { OverlayModalType } from "themes/default-tailwind/modals/module"
import { OverlayState } from "./types"

export const defaultBackgroundClose = true

export const initialState: OverlayState = {
    title: "",
    description: "",
    contentComponentName: undefined,
    contentComponentType: undefined,
    isVisible: false,
    componentQueue: [],
    backgroundClose: defaultBackgroundClose,
    type: OverlayModalType.General,
    workspaceConfirmationContext: undefined,
}
